import { Box } from "@mui/material";
import Home from "../components/Home";

export default function HomePage() {
  return (
    <Box>
      <Home />
    </Box>
  );
}
